module.exports = __webpack_public_path__ + "static/img/erweima.654a0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 26